import { handleActions, combineActions } from "redux-actions";

import {
	getShopsAsyncAction,
	getShopAsyncAction,
	updateShopStatusAsyncAction,
} from "./shopActions";

const initialState = {
	list: {
		items: [],
		meta: {
			currentPage: 0,
			totalPages: 0,
		},
	},

	detail: {
		status: "",
		user: {},
	},

	fetch: {
		loading: false,
		error: "",
	},

	action: {
		loading: false,
		success: false,
		error: "",
	},
};

export const shopReducer = handleActions(
	new Map([
		[
			getShopsAsyncAction.request,
			(state) => ({
				...state,
				fetch: {
					...initialState.fetch,
					loading: true,
				},
			}),
		],
		[
			getShopsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				fetch: {
					...initialState.fetch,
				},
				list: payload,
			}),
		],
		[
			getShopAsyncAction.success,
			(state, { payload }) => ({
				...state,
				detail: payload,
			}),
		],
		[
			combineActions(
				updateShopStatusAsyncAction.request,
				getShopsAsyncAction.request
			),
			(state) => ({
				...state,
				action: {
					...initialState.action,
					loading: true,
				},
			}),
		],
		[
			updateShopStatusAsyncAction.success,
			(state, { payload }) => ({
				...state,
				action: {
					...initialState.action,
					success: payload,
				},
			}),
		],
	]),
	initialState
);
